<template>
  <div>
    <ejs-grid :dataSource="strategyData" ref="strategyGrid" :dataBound='dataBound' :selectionSettings='selectionOptions' height="400">
      <e-columns>
        <e-column field="strategyId" :visible="false" :isPrimaryKey="true"></e-column>
        <e-column field="strategyName" :headerText="$t('Security.Strategy.name')" width="120" textAlign="Center"></e-column>
        <e-column field="startDate" :headerText="$t('Security.Strategy.startDate')" :format="dateFormat" type='date' width="120" textAlign="Center"></e-column>
        <e-column field="endDate" :headerText="$t('Security.Strategy.endDate')" :format="dateFormat" type='date' width="120" textAlign="Center"></e-column>
        <e-column field="startTime" :headerText="$t('Security.Strategy.startTime')" width="120" textAlign="Center"></e-column>
        <e-column field="endTime" :headerText="$t('Security.Strategy.endTime')" width="120" textAlign="Center"></e-column>
        <e-column field="week" :headerText="$t('Security.Strategy.weekday')" width="120" textAlign="Center"></e-column>
        <e-column field="description" :headerText="$t('Security.User.desc')" width="120" textAlign="Center"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
import { Resize } from '@syncfusion/ej2-vue-grids';

export default {
  name: 'AccountStrategy',
  data() {
    return {
      selectedId: '',
      selectIndex: 0,
      strategyData: [],
      selectionOptions: {
        type: 'Single', mode: 'Row'
      },
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd'
      },
      weekStatic: {
        '1': `${this.$t("Security.Strategy.monday")}`,
        '2': `${this.$t("Security.Strategy.tuesday")}`,
        '3': `${this.$t("Security.Strategy.wednesday")}`,
        '4': `${this.$t("Security.Strategy.thursday")}`,
        '5': `${this.$t("Security.Strategy.friday")}`,
        '6': `${this.$t("Security.Strategy.saturday")}`,
        '7': `${this.$t("Security.Strategy.sunday")}`,
      }
    };
  },
  mounted() {
  },
  methods: {
    init(selectedId) {
      this.selectedId = selectedId;
    },
    getStrategyList() {
      const url = '/lte/ems/strategy/findTimeStrategy';
      const params = { params: {} };
      const That = this;
      this.axios.get(url, params).then(response => {
        const strategyList = [];
        const result = response.data;
        result.forEach((item, index) => {
          const sta = {};
          sta.strategyId = item.strategyId;
          if (item.strategyId == That.selectedId) {
            That.selectIndex = index;
          }
          sta.strategyName = item.items['tss.name'];
          sta.startDate = item.items['tss.startDate'];
          sta.endDate = item.items['tss.endDate'];
          sta.startTime = item.items['tss.startTime'];
          sta.endTime = item.items['tss.endTime'];
          sta.week = That.convertWeek(item.items['tss.week']);
          sta.description = item.items['tss.des'];
          strategyList.push(sta);
        });
        That.strategyData = strategyList;
      });
    },
    convertWeek(data) {
      let weekStr = data
      if (!!data) {
        let weekArr = data.split(",")
        weekArr = weekArr.sort((a,b) => {
          return parseInt(a)-parseInt(b);
        }).map(item => {
          return this.weekStatic[item];
        })
        weekStr = weekArr.join(",")
      }
      return weekStr;
    },
    dataBound(arg) {
      this.$refs.strategyGrid.autoFitColumns(['strategyName', 'startDate', 'endDate', 'week', 'description']);
      this.$refs.strategyGrid.selectRow(this.selectIndex, false);
    },
    getSelectStrategy() {
      return this.$refs.strategyGrid.ej2Instances.getSelectedRecords();
    }
  },
  provide: {
    grid: [Resize]
  }
};
</script>
